<template>
  <NuxtLink class="app-docs-card" :to="to">
    <div class="app-docs-card-inner group">
      <AspectRatio :ratio="16 / 9" class="overflow-hidden">
        <NuxtImg
          class="h-full w-full transition-transform duration-500 lg:group-hover:scale-110"
          :src="cover"
          alt=""
          loading="lazy"
          format="webp"
          quality="80"
        />
      </AspectRatio>
      <div class="app-docs-card-content">
        <GfrTitle :level="4" class="app-docs-card-title" :placement="$route.params.lang === 'ar' ? 'right' : 'left'">
          {{ title }}
        </GfrTitle>
        <p class="app-docs-card-desc">
          {{ description }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { AspectRatio } from '@/components/ui/aspect-ratio'
import { TutorialConfig } from '~/server/types'
const props = defineProps({
  to: { type: String, default: '' },
  tutorialConfig: {
    type: Object as PropType<TutorialConfig>,
    required: true
  }
})

const { image: cover, title, profile: description } = toRefs(props.tutorialConfig)
</script>
<style lang="scss" scoped>
.app-docs-card-inner {
  @apply relative overflow-hidden transition-colors duration-300;
}

.app-docs-card-content {
  @apply absolute px-4 py-2 w-full bottom-0 left-0;
  @apply after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[88px] after:bg-gradient-to-t after:from-black after:to-transparent;
  // @apply px-5 pb-6 pt-3 max-lg:portrait:px-7.5 max-lg:portrait:pb-10.5 max-lg:portrait:pt-4.5;
  // mobile
  @apply max-lg:py-1;
}

.app-docs-card-title {
  @apply z-[1] relative mb-1 truncate text-[16px]/[24px] text-white font-medium ltr:pl-3 rtl:pr-3;
  @apply before:absolute before:top-1 before:h-4 before:w-1 before:bg-primary before:content-[''] before:ltr:left-0;
  @apply before:rtl:right-0;
  // mobile
  @apply max-lg:before:top-[5px] max-lg:font-regular max-lg:before:w-[2px] max-lg:before:h-2;
  @apply max-lg:text-[12px]/[18px];
  // landscape
  @apply landscape:max-lg:mb-[2px] landscape:max-lg:ltr:pl-[4px] landscape:max-lg:rtl:pr-[4px];
}

.app-docs-card-desc {
  @apply z-[1] relative text-[14px]/[22px] text-white lg:line-clamp-2 ltr:pl-3 rtl:pr-3;
  // mobile
  @apply max-lg:text-[12px]/[14px] max-lg:text-[#d1d1d1] max-lg:line-clamp-1 max-lg:mb-[2px];
  //  landscape
  @apply max-lg:ltr:pl-[6px] max-lg:rtl:pl-[6px];
  //   after
  @apply after:content-[''] after:absolute after:w-[4px] after:h-[4px] ltr:after:left-0 rtl:after:right-0 after:top-[9px] after:bg-white;
  @apply max-lg:after:bg-[#d1d1d1] max-lg:after:top-[6px]  max-lg:after:w-[2px] max-lg:after:h-[2px];
}
</style>
